export default "__VITE_ASSET__5b1cc71a__"